/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'goal-content.goal-about-content.description-edit-button': 'Bearbeiten',
  'project-actions.project-content-about.edit-description-error-description':
    'Etwas ist schiefgelaufen. Versuchen Sie es in ein paar Minuten erneut.',
  'project-content.project-content-about.edit-description-error-title':
    'Beschreibung des Projekts konnte nicht geändert werden',
  'project-content.project-content-about.the-measure-placeholder':
    'Beschreiben Sie, wie Sie Erfolg definieren und was Sie erreichen möchten.',
  'project-content.project-content-about.the-measure-title': 'Woran erkennen wir Erfolg?',
  'project-content.project-content-about.the-what-placeholder':
    'Beschreiben Sie dieses Projekt und die Aufgaben, die es umfasst.',
  'project-content.project-content-about.the-what-title': 'Was tun wir?',
  'project-content.project-content-about.the-why-placeholder':
    'Erläutern Sie, warum diese Aufgaben durchgeführt werden und welche Motive dahinter stehen.',
  'project-content.project-content-about.the-why-title': 'Warum tun wir das?',
  'project-content.project-content-update-date.edited': '(bearbeitet)',
  'project-content.project-content-update-date.edited-tooltip': 'Bearbeitet am {date}',
  'project-content.project-content-update-date.last-edited-by': '(zuletzt bearbeitet von {name})',
  'project-content.project-content-updates.add-update': 'Update hinzufügen',
  'project-content.project-content-updates.archived': 'Archiviert',
  'project-content.project-content-updates.at-risk': 'In Gefahr',
  'project-content.project-content-updates.cancelled': 'Abgebrochen',
  'project-content.project-content-updates.completed': 'Abgeschlossen 🎉',
  'project-content.project-content-updates.date-changed': 'Datum geändert',
  'project-content.project-content-updates.edit-update': 'Bearbeiten',
  "project-content.project-content-updates.for-date'": 'für den {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Neuestes Update',
  'project-content.project-content-updates.missed-update-message': 'Es wurde kein Update veröffentlicht.',
  'project-content.project-content-updates.new-due-date': 'Neues Fälligkeitsdatum',
  'project-content.project-content-updates.new-state': 'Neuer Status',
  'project-content.project-content-updates.no-updates-description':
    'Für dieses Projekt sind noch keine Updates vorhanden.',
  'project-content.project-content-updates.off-track': 'Nicht auf Kurs',
  'project-content.project-content-updates.old-due-date': 'Altes Fälligkeitsdatum',
  'project-content.project-content-updates.old-state': 'Alter Status',
  'project-content.project-content-updates.on-track': 'Auf Kurs',
  'project-content.project-content-updates.paused': 'Angehalten',
  'project-content.project-content-updates.pending': 'Ausstehend',
  'project-content.project-content-updates.previous-updates-title': 'Vorherige Updates',
  'project-content.project-content-updates.share-update': 'Teilen',
  'project-content.project-content-updates.status-changed': 'Status geändert',
  'project-content.project-content-updates.write-update-button': 'Ein Update schreiben',
  'project-update-composer.modal-post-button-label': 'Update veröffentlichen',
  'project-update-composer.modal-title': 'Veröffentlichen Sie Ihr Update.',
};
